/* eslint-disable @eslint-react/no-children-map,@eslint-react/no-children-to-array */
import { Children } from 'react';

import Accordion from '~/common/components/Accordions/Accordion';
import AccordionButton from '~/common/components/Accordions/AccordionButton';
import AccordionIcon from '~/common/components/Accordions/AccordionIcon';
import AccordionItem from '~/common/components/Accordions/AccordionItem';
import AccordionPanel from '~/common/components/Accordions/AccordionPanel';
import Box from '~/common/components/Box';
import Text from '~/common/components/Texts/Text';

type AccordionWrapperProps = {
  children: React.ReactElement<{ children: React.ReactNode }>[];
  allowMultiple?: boolean;
  hide?: boolean;
};

const AccordionWrapper = ({
  children,
  allowMultiple = false,
  hide,
}: Readonly<AccordionWrapperProps>) => {
  if (hide) {
    return (
      <Box
        m="1rem"
        py="1rem"
        pl="24px"
        border="1px solid"
        borderColor="gray.200"
      >
        {Children.map(children, (child) => {
          const [title, body] = Children.toArray(child.props.children);
          return (
            <div key={child.key}>
              <Text as="h4" fontSize="1rem" textDecoration="underline">
                {title}
              </Text>
              {body}
            </div>
          );
        })}
      </Box>
    );
  }

  return (
    <Accordion allowMultiple={allowMultiple}>
      {Children.map(children, (child) => {
        const [title, body] = Children.toArray(child.props.children);
        return (
          <AccordionItem
            borderWidth="1px"
            borderStyle="solid"
            borderColor="gray.200"
            borderRadius="4px"
            mb="16px"
            key={child.key}
          >
            <Text as="h4" backgroundColor="gray.50">
              <AccordionButton>
                {title}
                <AccordionIcon />
              </AccordionButton>
            </Text>
            <AccordionPanel pb={4} pr={0} borderColor="gray.200">
              {body}
            </AccordionPanel>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
};

export default AccordionWrapper;
